module.exports = __webpack_public_path__ + "static/media/1_CONNECTED TO CATS-EYES BRACELET_TI.781dd4d6.txt";